import { PATHS } from "@/lib/router";
import { MoreSolutionsPage } from "./pages";

export const moreSolutionsRoutes = [
  {
    path: PATHS.MORE_SOLUTIONS,
    element: <MoreSolutionsPage />,
  },
];
